import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';
import { HomeFilter, ClientConfiguration } from 'src/app/models/client-configuration';
import { ChallengesFacade } from '../../challenges/state/challenges.facade';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  globalChallenge$ = this.challengesFacade.globalChallenge$;
  assignedChallenge$ = this.challengesFacade.assignedChallenge$;

  config: ClientConfiguration;
  homeFilter: HomeFilter;
  fadedBanner: boolean;
  showHomeFilter: boolean;
  showChallengeBar: boolean;

  constructor(
    private router: Router,
    private authService: AuthService,
    private configService: ConfigService,
    private readonly challengesFacade: ChallengesFacade,
    ) {
    this.config = configService.get();
    this.homeFilter = this.config.homeFilter;
    this.fadedBanner = this.config.showFadedBanner && this.config.banners.length > 0;

    this.showHomeFilter = this.homeFilter.type === 'SLIDER' && this.homeFilter.firstLevel != undefined;
    this.showChallengeBar =
      configService.get().showChallengeFeatures != undefined ? configService.get().showChallengeFeatures : false;
  }

  ngOnInit() {
    this.challengesFacade.getAdminChallenges().subscribe();

    const afterLoginUrl = sessionStorage.getItem('afterLogin');
    if (afterLoginUrl) {
      sessionStorage.removeItem('afterLogin');
      window.location.href = window.location.origin + afterLoginUrl;
    }

    if (this.shouldShowAulaMadridLanding()) {
      this.router.navigate(['aula-madrid']);
    }
  }

  private shouldShowAulaMadridLanding(): boolean {
    const clientCode = this.configService.isAulaMadrid();
    const isLandingLoaded = window.sessionStorage.getItem('aula-madrid-login') && window.sessionStorage.getItem('aula-madrid-login') === 'true';

    return clientCode && !isLandingLoaded && !this.authService.isAuthenticated();
  }
}
